import {
  useState,
  useEffect,
  useContext,
} from 'react';
import { firestore } from '../../firebase';
import { UseToastsContext } from '../contexts/UseToastsContext';
import {
  UseAuthUserContext,
} from '../contexts/UseAuthUserContext';

const useGraduateAccountInfo = (history)  => {
  const {
    setError,
    setSuccess,
    isLoading,
    setIsLoading,
  } = useContext(UseToastsContext);
  const {
    authUser,
  } = useContext(UseAuthUserContext);
  const {
    id: authUserId,
    name: currentName,
    surname: currentSurname,
    position: currentPosition,
    corporateName: currentCorporateName,
    country: currentCountry,
    city: currentCity,
    address: currentAddress,
    zipCode: currentZipCode,
  } = authUser || {
    id: '',
    name: '',
    surname: '',
    position: '',
    corporateName: '',
    country: '',
    city: '',
    address: '',
    zipCode: '',
  };
  const [name, setNameLow] = useState(currentName);
  const [surname, setSurname] = useState(currentSurname);
  const [position, setPosition] = useState(currentPosition);
  const [corporateName, setCorporateName] = useState(currentCorporateName);
  const [country, setCountry] = useState(currentCountry);
  const [city, setCity] = useState(currentCity);
  const [address, setAddress] = useState(currentAddress);
  const [zipCode, setZipCode] = useState(currentZipCode);
  const [isDisabled, setIsDisabled] = useState(true);

  const setName = (name) => {
    setNameLow(name.toUpperCase())
  }

  useEffect(
    () => {
      setIsDisabled(
        name.trim() === ''
        || surname.trim() === ''
        || corporateName.trim() === ''
        || address.trim() === ''
        || zipCode.trim() === ''
        || city.trim() === ''
        || country.trim() === ''
      );
    },
    [name, surname, corporateName, address, zipCode, city, country],
  );

  const updateMyInfo = (): void => {
    if (isLoading || isDisabled) {
      setError({ message: 'fillAllInformation' });
    }
    else {
      setIsLoading(true);
      if (authUserId !== '') {
        firestore.updateUser(
          authUserId,
          {
            surname,
            name: name.toUpperCase(),
            position,
            corporateName,
            address,
            city,
            zipCode,
            country,
            updatedOn: firestore.createTimeStamp(),
          },
        ).then(() => {
          setSuccess({ message: 'infoUpdateSuccess' });
          setIsLoading(false);
        }).catch((e) => {
          setError(e);
          setIsLoading(false);
        });
      } else {
        setError({ message: 'userNotFound' });
        setIsLoading(false);
      }
    }
  };

  return {
    name,
    setName,
    surname,
    setSurname,
    position,
    setPosition,
    address,
    setAddress,
    city,
    setCity,
    zipCode,
    setZipCode,
    country,
    setCountry,
    corporateName,
    setCorporateName,
    isDisabled,
    isLoading,
    updateMyInfo,
  };
};

export default useGraduateAccountInfo;
